import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { hoverBg100 } from '@osmosis/tailwind-ui/styles/background';

import { Toggle } from '../Toggle';
import { PopupMenuItem } from './PopupMenu';

type Props = {
  item: PopupMenuItem;
  checked: boolean;
  onToggle: () => void;
  testDataKey?: string | number;
  className?: string;
};

/**
 * PopupMenuRowWithToggle.
 */
const PopupMenuRowWithToggle = (props: Props) => {
  const { item, checked, onToggle, testDataKey, className } = props;

  return (
    <Flex
      onClick={onToggle}
      data-testid={`row-with-toggle-btn-${testDataKey}`}
      className={`h-[55px] w-full cursor-pointer items-center justify-between gap-3 hover:rounded-[4px] ${hoverBg100} ${className}`}
    >
      <Flex>
        {item.icon && (
          <Box className="ml-3 basis-[22px]">
            <Icon icon={item.icon} />
          </Box>
        )}
        <P className="ml-[15px] whitespace-break-spaces sm:whitespace-nowrap">
          {item.text}
        </P>
      </Flex>
      <Flex className="pointer-events-none mr-3">
        <Toggle
          data-testid={`popup-menu-row-toggle-${testDataKey}`}
          size={14}
          checked={checked}
          buttonProps={{
            'aria-label': item.text,
            'aria-checked': checked,
          }}
        />
      </Flex>
    </Flex>
  );
};

export default PopupMenuRowWithToggle;
